import React from 'react';
import { FadeIn } from './FadeIn';
import { MessageCircleOff, Clock, Smartphone } from 'lucide-react';
export function PainSection() {
  return <section className="py-16 md:py-32 relative bg-deep-black" data-id="element-177">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-24 bg-gradient-to-b from-champagne-gold/50 to-transparent" data-id="element-178"></div>
      <div className="absolute top-1/4 -left-64 w-96 h-96 bg-burgundy/20 rounded-full blur-[120px]" data-id="element-179"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-180">
        <FadeIn data-id="element-181">
          <h2 className="font-playfair text-3xl md:text-5xl text-center mb-10 md:mb-16 text-cream leading-tight" data-id="element-182">
            Vous avez un match incroyable.
            <br data-id="element-183" />
            La conversation pétille.
            <br data-id="element-184" />
            <span className="text-champagne-gold italic" data-id="element-185">Et soudain…</span>
          </h2>
        </FadeIn>

        <div className="grid gap-5 md:gap-8 md:grid-cols-3 mb-12 md:mb-20" data-id="element-186">
          <FadeIn delay={0.2} className="bg-glass-burgundy backdrop-blur-md border border-burgundy/30 rounded-3xl p-8 text-center" data-id="element-187">
            <MessageCircleOff className="w-10 h-10 text-champagne-gold mx-auto mb-6 opacity-80" data-id="element-188" />
            <h3 className="font-playfair text-xl mb-4 text-cream" data-id="element-189">
              Le Silence
            </h3>
            <p className="text-muted-cream text-sm leading-relaxed font-light" data-id="element-190">
              Il voit vos messages. Il ne répond pas. Vous fixez l'écran en
              attendant une notification qui ne vient pas.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} className="bg-glass-burgundy backdrop-blur-md border border-burgundy/30 rounded-3xl p-8 text-center" data-id="element-191">
            <Clock className="w-10 h-10 text-champagne-gold mx-auto mb-6 opacity-80" data-id="element-192" />
            <h3 className="font-playfair text-xl mb-4 text-cream" data-id="element-193">
              Le Retour Facile
            </h3>
            <p className="text-muted-cream text-sm leading-relaxed font-light" data-id="element-194">
              Il revient trois jours plus tard avec un "Coucou ça va ?" comme si
              de rien n'était. Vous méritez mieux.
            </p>
          </FadeIn>

          <FadeIn delay={0.6} className="bg-glass-burgundy backdrop-blur-md border border-burgundy/30 rounded-3xl p-8 text-center" data-id="element-195">
            <Smartphone className="w-10 h-10 text-champagne-gold mx-auto mb-6 opacity-80" data-id="element-196" />
            <h3 className="font-playfair text-xl mb-4 text-cream" data-id="element-197">
              L'Épuisement
            </h3>
            <p className="text-muted-cream text-sm leading-relaxed font-light" data-id="element-198">
              Être patiente. Être drôle. Être disponible. Vous avez tout essayé,
              mais le résultat reste le même.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.8} data-id="element-199">
          <div className="max-w-2xl mx-auto text-center space-y-8" data-id="element-200">
            <p className="text-2xl font-playfair text-champagne-gold italic" data-id="element-201">
              Ce n'est pas votre faute.
            </p>
            <p className="text-muted-cream leading-relaxed font-light text-lg" data-id="element-202">
              Les applications de rencontre ne sont pas conçues pour vous faire
              trouver l'amour. Elles sont conçues pour vous garder dessus le
              plus longtemps possible. Et les hommes ? Ils sont devenus
              tellement habitués à l'abondance digitale qu'ils ont oublié de
              faire des efforts.
            </p>
            <p className="text-cream font-medium text-xl font-playfair" data-id="element-203">
              Jusqu'à maintenant. Parce que vous vous apprêtez à changer les
              règles du jeu.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}